import { Component } from "@angular/core";

@Component({
  selector: "icon-ajuste-pension-billetera",
  templateUrl: "./ajuste-pension-billetera.svg",
  standalone: true,
})
export class AjustePensionBilleteraComponent {}